<template>
  <div>
    <div v-if="selectedMark">
      <h3 class="title title--small">Marker Content</h3>

      <div v-if="!selectedMark.handleNext">
        <div class="field">
          <label class="label" for="scene-headline">Label</label>
          <input type="text" id="scene-headline" v-on:keydown="handleInputChange" v-model="selectedMark.label[lang]" class="input" />
        </div>
        <div class="field">
          <label class="label" for="scene-subheadline">Link</label>
          <input type="text" id="scene-subheadline" v-on:keydown="handleInputChange" v-model="selectedMark.link[lang]" class="input" />
        </div>
        <div class="field actions jc">
          <button
            class="button button--icon button--delete-mark"
            @click="deleteMarker((selectedMark._id || selectedMark.id))"
          >
            <img :src="require('../../assets/editor/bin-icon.svg')" />
            Delete Marker
          </button>
        </div>
      </div>
      <div v-else>
        <div class="field">
          <label class="label" for="scene-headline">Label</label>
          <input type="text" id="scene-headline" v-on:keydown="handleInputChange" v-model="selectedMark.label[lang]" class="input" />
        </div>
        <div class="field">
          <label class="label">Select subscene</label>
          <select class="input input--outline" v-model="selectedMark.handleNext" @change="handleChangeNavigation($event)">
            <option
              v-for="subscene in subscenes"
              :value="subscene._id"
              :key="subscene._id"
            >{{subscene.name}}</option>
          </select>
        </div>
        <div class="field actions jc">
          <button
            class="button button--icon button--delete-mark"
            @click="deleteMarker((selectedMark._id || selectedMark.id))"
          >
            <img :src="require('../../assets/editor/bin-icon.svg')" />
            Delete Marker
          </button>
        </div>
      </div>
    </div>

    <h3 class="title title--small">Text Edit</h3>
    <div class="controls">
      <div class="field">
        <label class="label" for="scene-headline">Headline</label>
        <input type="text" id="scene-headline" v-on:keydown="handleInputChange" v-model="title[lang]" class="input" />
      </div>
      <div class="field">
        <label class="label" for="scene-subheadline">Subheadline</label>
        <input type="text" id="scene-subheadline" v-on:keydown="handleInputChange" v-model="subtitle[lang]" class="input" />
      </div>
      <div class="field">
        <div class="field">
          <label class="label" for="scene-textbox-title">Textbox (Title)</label>
          <input
            type="text"
            id="scene-textbox-title"
            v-model="information['title'][lang]"
            class="input"
            v-on:keydown="handleInputChange"
          />
        </div>
        <div class="field">
          <label class="label" for="scene-textbox-text">Textbox (Text)</label>
          <textarea class="input" v-on:keydown="handleInputChange" id="scene-textbox-text" v-model="information['text'][lang]"></textarea>
        </div>
        <div v-for="link in information['links'][lang]"
            :value="link"
            :key="link._id">
            <div class="field">
              <label class="label" for="scene-textbox-link-text">Textbox (Link text)</label>
              <input
                type="text"
                id="scene-textbox-link-text"
                v-model="link.text"
                class="input"
                v-on:keydown="handleInputChange"
              />
            </div>

            <div class="field">
              <label class="label" for="scene-textbox-link-url">Textbox (Link url)</label>
              <input
                type="text"
                id="scene-textbox-link-url"
                v-model="link.url"
                class="input"
                v-on:keydown="handleInputChange"
              />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import api from "../../api";
import { getProjectScenes } from "../../utils";

export default {
  data() {
    return {
      title: {
        en: "",
        de: ""
      },
      subtitle: {
        en: "",
        de: ""
      },
      information: {
        title: {
          en: "",
          de: ""
        },
        text: {
          en: "",
          de: ""
        },
        links: {
          en: [{
            text: "",
            url: ""
          }],
          de: [{
            text: "",
            url: ""
          }]
        }
      }
    };
  },
  props: {
    scene: Object
  },
  computed: {
    ...mapState(["lang", "selectedScene", "selectedProject", "selectedMark", "scenes", "unsavedScenes"]),
    subscenes() {
      return getProjectScenes(this.selectedProject).filter(
        s => s.type === "subscene"
      );
    },
    isUnsaved() {
      return this.unsavedScenes.find(s => s._id === this.selectedScene._id);
    }
  },
  mounted() {
    const { title, subtitle, information } = this.scene;

    this.title = title;
    this.subtitle = subtitle;
    this.information = information;

    if(!information.links.de.length) {
      this.information.links.de = [{text: "", url: ""}]
    }

    if(!information.links.en.length) {
      this.information.links.en = [{text: "", url: ""}]
    }
  },
  methods: {
    ...mapMutations([
      "setSelectedScene",
      "setSelectedProject",
      "setSelectedMark",
      "saveLocalScene",
      "addUnsavedScene",
      "saveUnsavedScene",
      "deleteMark"
    ]),
    handleChangeNavigation(event) {
      this.selectedMark.handleNext = event.currentTarget.value;
      this.saveLocalScene(this.selectedScene);
      this.addUnsavedScene(this.selectedScene);
    },
    handleInputChange() {
      this.saveLocalScene(this.selectedScene);
      this.addUnsavedScene(this.selectedScene);
      // console.log(this.selectedScene);
    },
    deleteMarker: function(id) {
      const index = this.unsavedScenes
        .map(s => s._id)
        .indexOf(this.selectedScene._id);

      this.deleteMark({
        index,
        markerId: id
      });

      this.setSelectedMark(null);
      if (index !== -1) {
        this.setSelectedScene(this.unsavedScenes[index]);
      }
      this.saveLocalScene(this.selectedScene);
      this.addUnsavedScene(this.selectedScene);
    }
  }
};
</script>

<style lang="scss" scoped>
.field.actions.jc {
  justify-content: space-between;
}
</style>
